module.exports = __webpack_public_path__ + "img/user-admin-icon.31223db9.svg";